import _ from 'lodash';
import angular from 'angular';

const userInstrumentActionsfactory = function NewMerchantProfileService($rootScope, $q, $log, $http, endPoints, Dispatcher, StorageService, NewBackendService, NewUserInstrumentStore) {
        "ngInject";

      /**
       * normalizeBalance : converte il saldo da centesimi in interi con due numeri dopo la virgola
       *
       * @param  {number} rawImport
       * @return {float}
       */
      const normalizeBalance = function(rawImport){
        let output = rawImport;
        if (output !== 0) {
            output = output / 100.0;
        }
        return output.toFixed(2);
      };


        /**
         * getInstrumentBalance : ottieni il saldo del wallet indicato
         *
         * @param  {number} [m] instrumentId
         * @param  {boolean} [m] isBackground
         * @param  {boolean} [o] getPan
         * @param  {boolean} [o] isBoth
         */
        const getInstrumentBalance = function(instrumentId, isBackground, getPan = false, isBoth = false) {
            return $q(function(resolve, reject) {
                const isSuperAdmin = StorageService.getLocalStorage('superAdmin');
                const userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
                const url = `${endPoints.userUrl}/wallet-instruments/${isSuperAdmin ? userContext.walletId+"/" : ""}${instrumentId}/balance`;

                NewBackendService.invokeWebApiGet(url, isBackground).then(function(result) {
                    if (getPan === true) {
                        resolve(result.data.obscuredPan);
                        return;
                    } else if(isBoth){
                      const
                        accountBalance = result.data.accountBalance ? parseFloat(result.data.accountBalance) : 0,
                        balance = {
                          "disponibile" : normalizeBalance(parseFloat(result.data.availableBalance)),
                          "contabile" :  _.isNumber(accountBalance) ? normalizeBalance(accountBalance) : undefined
                        };
                      resolve(balance);
                    } else {
                        let balance = result.data.availableBalance ? parseFloat(result.data.availableBalance) : 0
                        balance = normalizeBalance(balance);

                        result.data.availableBalance = balance;
                        resolve(balance);
                    }
                }, function(reason) {
                    reject(reason);
                });
            });
        };

        const richiediCarta = function(indirizzoSpedizioneCarta, label = "Carta prepagata", type = "L1", commission = false) {
            return $q(function(resolve, reject) {
                const URL = "registrazione/richiediCarta";
                const request = {
                    "userContext": {},
                    "data": {
                        "request": {
                            "richiediCartaRequest": {
                                "commission": commission,
                                "label": label,
                                "type": type
                            }
                        }
                    }
                };
                if (indirizzoSpedizioneCarta) {
                    request.data.request.richiediCartaRequest.indirizzoSpedizioneCarta = indirizzoSpedizioneCarta;
                }
                NewBackendService.invokeWebApiPost(URL, request).then(function(result) {
                    resolve(result);
                }, function(reason) {
                    reject(reason);
                });
            });
        };

        return {
            getUserInstrumentList: function(isBackground, isRobo = false) {
                $log.debug("getUserActions called");
                Dispatcher.dispatch({
                    actionType: "USERINSTRUMENT_START_LOAD_INSTUMENT_LIST",
                    data: undefined,
                    state: "STORE_PENDING_UPDATE"
                });
                const isSuperAdmin = StorageService.getLocalStorage('superAdmin');
                const userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
                NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/wallet-instruments/${isSuperAdmin ? userContext.businessId+"/" : ""}${isSuperAdmin ? userContext.walletId : ""}`, {"returnDeletedAccount": false}, isBackground).
                then(function(response) {
                        console.log(response);
                        if (response.data._embedded !== undefined) {
                            const list = response.data._embedded.walletInstruments;
                            Dispatcher.dispatch({
                                actionType: "USERINSTRUMENT_LOAD_INSTUMENT_LIST",
                                data: list,
                                state: "STORE_VALID"
                            });
                            $log.debug('NewMerchantProfileService', 'list', list);
                        }
                    },
                    function(reason) {
                        $log.debug(reason);
                        Dispatcher.dispatch({
                            actionType: "USERINSTRUMENT_LOAD_INSTUMENT_LIST_FAIL",
                            data: {},
                            state: "STORE_FAILED_UPDATE"
                        });
                    });

            },
            /**
             * DA UTILIZZARE DOPO AVER CONTROLLATO SE LO STATO DELLO STORE E' VALID, CIOE' DOPO AVER VERIFICATO DI AVER CARICATO LA LISTA STRUMENTI
             */
            getWalletBalance: function(isBoth = false) {
                const wallet = angular.copy(NewUserInstrumentStore.getWallet());
                if (wallet) {
                    Dispatcher.dispatch({
                        actionType: "USERINSTRUMENT_START_WALLETBALANCE_LOAD",
                        data: undefined
                    });
                
                    const walletId = wallet.walletInstrumentResource.idWalletInstrument;
                    getInstrumentBalance(walletId, true, false, isBoth).then(function(result) {
                        Dispatcher.dispatch({
                            actionType: "USERINSTRUMENT_WALLETBALANCE_LOAD",
                            data: result
                        });
                    }, function(reason) {
                        $log.error(reason);
                        Dispatcher.dispatch({
                            actionType: "USERINSTRUMENT_WALLETBALANCE_LOAD_FAIL",
                            data: reason
                        });
                    });
                } else {
                    $log.log("Wallet is undefined: retrive instument list BEFORE get Instrument balace");
                }
            },
            getAccountBalance : function(){
              return $q(function(resolve,reject){
                //TODO store
                const wallet = angular.copy(NewUserInstrumentStore.getWallet());
                if (wallet) {
                  const walletId = wallet.idUserInstrument;
                  getInstrumentBalance(walletId, true, false, true).then(function(result){
                    resolve(result);
                  }, function(reason){
                    reject(reason);
                  });
                } else {
                  reject("No wallet founded yet");
                }
              });
            },
            getPrepaidCardPan: function () {
                const card = angular.copy(NewUserInstrumentStore.getPrepaidCard());
                if (card) {
                    Dispatcher.dispatch({
                        actionType: 'USERINSTRUMENT_CARDPAN_LOAD_START',
                        state: 'STORE_PENDING_UPDATE'
                    });

                    const cardId = card.idUserInstrument;

                    getInstrumentBalance(cardId, true, true).then(function (result) {
                        Dispatcher.dispatch({
                            actionType: 'USERINSTRUMENT_CARDPAN_LOAD',
                            data: result,
                            state: 'STORE_VALID'
                        });
                    }, function (reason) {
                        $log.error('NewMerchantProfileService', 'getPrepaidCardPan', reason);
                        Dispatcher.dispatch({
                            actionType: 'USERINSTRUMENT_CARDPAN_LOAD_FAIL',
                            data: reason,
                            state: 'STORE_FAILED_UPDATE'
                        });
                    });
                } else {
                    $log.log("NewMerchantProfileService", "getPrepaidCardPan", "prepaidCard is undefined");
                }
            },
            getPrepaidCardBalance: function() {
                const card = angular.copy(NewUserInstrumentStore.getPrepaidCard());
                if (card) {
                    Dispatcher.dispatch({
                        actionType: "USERINSTRUMENT_START_CARDBALANCE_LOAD",
                        data: undefined
                    });
                    const cardId = card.idUserInstrument;
                    getInstrumentBalance(cardId, true).then(function(result) {
                        Dispatcher.dispatch({
                            actionType: "USERINSTRUMENT_CARDBALANCE_LOAD",
                            data: result
                        });
                    }, function(reason) {
                        $log.error(reason);
                        Dispatcher.dispatch({
                            actionType: "USERINSTRUMENT_CARDBALANCE_LOAD_FAIL",
                            data: reason
                        });
                    });
                } else {
                    $log.log("NewMerchantProfileService", "getPrepaidCardBalance", "prepaidCard is undefined");
                }
            },
            getPrepaidCardInfo : function(instrumentId, isBackground = true) {
              return $q(function(resolve, reject){
                if(instrumentId === undefined){
                  reject("No instrumentId founded");
                }
                const url = 'wallet/getPrepaidCardInfo';
                const userObject = {
                    "data": {
                        "dtoReq": {
                            "dtoGetPrepaidCardInfoReq": {
                                "userInstrumentId": instrumentId
                            }
                        }
                    },
                    "userContext": {}
                };
                NewBackendService.invokeWebApiPost(url, userObject, isBackground).then(function(result) {
                  resolve(result.data.dtoRes.dtoGetPrepaidCardInfoRes.prapaidCardInfo);
                }, function(reason){
                  reject(reason);
                });
              });
            },

            richiediNuovaCarta: function(indirizzoSpedizioneCarta) {
                Dispatcher.dispatch({
                    actionType: "USERINSTRUMENT_REQUIRE_NEW_PREPAID_CARD_START",
                    data: undefined
                });
                richiediCarta(indirizzoSpedizioneCarta).then(function(result) {
                    Dispatcher.dispatch({
                        actionType: "USERINSTRUMENT_REQUIRE_NEW_PREPAID_CARD_SUCCESS",
                        data: result,
                        state: "STORE_EXPIRED"
                    });
                }, function(reason) {
                    Dispatcher.dispatch({
                        actionType: "USERINSTRUMENT_REQUIRE_NEW_PREPAID_CARD_FAIL",
                        data: reason
                    });
                });
            }
        };
    }
export default userInstrumentActionsfactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/userInstrumentAction.factory.js
 **/